import _ from 'lodash';
import { createScreens, screenFactory as onlineSurfaceFactory } from 'factories/screenFactory';
import * as Models from 'models';
import { intlGet } from 'utils/intlGet';

function prepareScreens(screens: Models.Screens, screenDefinitionId?: string): Models.Screens {
  if (!_.isEmpty(screens)) {
    return createScreens(screens);
  }

  const name = intlGet('Artboard', 'DefaultScreenName', { count: 1 });
  const defaultScreen = onlineSurfaceFactory({ name, screenDefinitionId });

  return { [defaultScreen.id]: defaultScreen };
}

export function prepareSurfacesProcess<T extends Models.GetProjectDataProcessArgs>({ assets }: T): void {
  const {
    surfaces,
    project: { surfaceIds },
    masterScreenData: { screenDefinitions },
  } = assets;

  const screens = prepareScreens(surfaces, _(screenDefinitions).keys().first());
  assets.surfaces = screens;

  if (_.isEmpty(surfaceIds) || !surfaceIds.every(surfaceId => !!screens[surfaceId])) {
    assets.project.surfaceIds = _.keys(screens);
  }
}
